export function getPostAuthPath({
  requiresPhone = false,
  needsOnboarding = false,
  useWorkspace = false,
  next = "",
} = {}) {
  if (requiresPhone) return "/complete-profile"
  if (needsOnboarding) return "/onboarding"
  if (typeof next === "string" && (next.startsWith("/admin/marketplace") || next.startsWith("/admin/blog"))) {
    return next
  }
  if (useWorkspace) return "/workspace"
  return "/dashboard"
}

export function recommendPlanKey(intent, needsStock, needsPosOrTeam) {
  if (needsPosOrTeam) return "ecosystem"
  const stock = intent === "manage" ? true : Boolean(needsStock)
  if (!stock) return "starter"
  return "business"
}
